<template>
  <div class="text">
    <p>确定标记为不合适？</p>
    <p>标记后用户将收到不合适通知</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    roleData: Object,
    dialogType: String
  },
  methods: {
    Submission(el) {
      this.$emit("datamaseg", {}, this.dialogType, true);
    }
  }
};
</script>

<style scope>
.text {
  color: #333333;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
  padding: 47px 0 41px;
}
</style>



// WEBPACK FOOTER //
// src/views/resume/components/signTypeMes.vue